export enum FeatureFlags {
    Maps = 'maps',
    TimeWindowSuggestions = 'time-window-suggestions',
    ManualRoutes = 'manual-routes',
    GroupTasksByPatientAndSkillRequirementFeature = 'use-internal-visit-history-for-patient-tasks-by-skill-requirement',
    RouteComparison = 'frp-route-comparison',
    FreeTimeBetweenTasks = 'OPLO-2251',
    TravelTimeToOffice = 'oplo-2235',
    ShiftSplit = 'oplo-2250-shift-split',
    GeneralTaskSkillUpdate = 'oplo-2240-general-skill-update',
    CriticalRosterPriority = 'oplo-2314-critical-roster-priority',
    PrioritizePatientTasks = 'oplo-1645-prioritize-patient-tasks',
    ZoomButtons = 'oplo-1630-zoom-buttons',
    LicenseAttribution = 'oplo-1470-license-attribution',
    OptimizationSettingsPlacement = 'oplo-2401-settings-placement',
    ReportIssueTab = 'oplo-2397-report-issue-tab',
    ColoringTasks = 'oplo-2437-task-colors',
    LastStepDragFix = 'oplo-2449-step-4-dragdrop-fix',
    FirstStepEmployeeEditOne = 'oplo-2517-employee-edit',
    MinimizeViewLastStep = 'oplo-2535-step-4-minimize-view',
    CancelDrop = 'oplo-2551-cancel-drop',
    SwapWorklists = 'oplo-swap-worklists',
    HighlightDelays = 'oplo-highlight-delays',
    IndependentSyncTasks = 'oplo-2576-independent-sync-tasks',
    SwapWorklistsTaskSelection = "oplo-2647-workshift-swap-task-selection",
    SurvicateCsat = 'oplo-survicate-csat',
    TravelTimeDistanceBaseline = 'oplo-2679-travel-time-distance-baseline'
}
